import { styled } from '@mui/material';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 25rem;
  height: 49.625rem;
  padding: 1rem 1.5rem;
  gap: 2rem;
  background-color: white;
`;

export const Header = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Title = styled('p')(({ theme }) => ({
  margin: 0,
  color: theme.palette.grey[950],
  fontSize: '1.125rem',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '120%',
}));

export const CloseButton = styled('div')`
  cursor: pointer;
`;

export const Content = styled('div')`
  overflow-y: auto;
  width: 100%;

  -ms-overflow-style: none;
  scrollbar-width: none;
`;
